import React, { Fragment } from "react";
import { getFieldPath } from "utils/form";
import TinSelect from "components/TinSelect";
import { useIsManifestEditMode } from "utils/hooks/manifest";
import FieldListFactory from "components/FieldListFactory";

const ValuesFields = ({ name }) => {
  const isEditMode = useIsManifestEditMode();
  const defaultPath = getFieldPath(name, "default");

  const defaultOptionSelect = (
    <div className="w-100 pt3">
      <label className="f6 mb2 dib fw6">Default</label>
      <TinSelect name={defaultPath} disabled={isEditMode} />
    </div>
  );

  return (
    <Fragment>
      <FieldListFactory
        name={name}
        config={[
          {
            name: "label"
          },
          {
            name: "description"
          }
        ]}
      />
      {defaultOptionSelect}
    </Fragment>
  );
};

export default ValuesFields;
